import { DEFAULT_TAX_LANGUAGE_KEY } from './constants';
import defaultTaxNames from './default-tax-names.json';
import taxNamesByCountry from './tax-names-by-country.json';
/**
 * @returns tax name from 3 letter country code (eg. 'usa') and language (eg. 'en'). Defaults to english ('Tax') if no matching language.
 */

export function getTaxName(countryCode, language) {
  var _ref, _countryCode$toLowerC, _countryCode$toLowerC2;
  if (countryCode === void 0) {
    countryCode = '';
  }
  if (language === void 0) {
    language = '';
  }
  return (_ref = (_countryCode$toLowerC = (_countryCode$toLowerC2 = taxNamesByCountry[countryCode.toLowerCase()]) == null ? void 0 : _countryCode$toLowerC2[language.toLowerCase()]) != null ? _countryCode$toLowerC : defaultTaxNames[language.toLowerCase()]) != null ? _ref : defaultTaxNames[DEFAULT_TAX_LANGUAGE_KEY];
}
//# sourceMappingURL=get-tax-name.js.map